// custom component (not registry-generated)
import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export { default as BlinkyAvatar } from './BlinkyAvatar.vue'

// Blinky — the AI-assistant mascot avatar, a faithful port of KUIUnifiedBlinky:
// a single soft-blurred lime glow with two ink SVG-ellipse eyes that blink and
// gaze. `size` (md/lg/xl/2xl) scales the container; the component maps the glow
// size, eye dimensions, eye gap and blur radius per size exactly as KUI does.
// `gaze` (centered/right/down/darting) drives the eye choreography — darting
// runs KUI's synced look-around timeline once, then settles to centered. Tokens
// only: `secondary` (lime) glow, `foreground` (ink) eyes — no raw palette, no
// illustration asset (the eyes are drawn).
export const blinkyAvatarVariants = cva(
  'relative flex items-center justify-center',
  {
    variants: {
      size: {
        'md': 'size-8',
        'lg': 'size-12',
        'xl': 'size-32',
        '2xl': 'size-48',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
)
export type BlinkyAvatarVariants = VariantProps<typeof blinkyAvatarVariants>
